(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["subscribe-prompt"] && !Shopify.designMode) return;
  try {
    (function () {
      var dialog = document.getElementById('subscribe-prompt');
      if (!dialog) return;

      var STORE_KEY = 'av_prompt_state';
      var DELAY_MS  = 10000;
      /* Backoff escalado: tras el 1er descarte vuelve en 7 dias, tras el
         2do en 30, y al 3ro no vuelve nunca. Quien se suscribe sale de la
         rueda para siempre. */
      var BACKOFF_DAYS = [7, 30];
      var DAY_MS = 86400000;

      var closeBtn = dialog.querySelector('[data-prompt-close]');
      var isMobile = window.matchMedia('(max-width: 768px)').matches;

      function readState() {
        try {
          return JSON.parse(localStorage.getItem(STORE_KEY)) || {};
        } catch (e) {
          /* Modo privado, almacenamiento bloqueado o JSON corrupto: el
             prompt sigue funcionando, solo pierde memoria entre visitas. */
          return {};
        }
      }

      function writeState(next) {
        try {
          localStorage.setItem(STORE_KEY, JSON.stringify(next));
        } catch (e) {}
      }

      function reveal() {
        /* Desktop: modal real — foco atrapado, Esc y backdrop gratis.
           Movil: show() para no bloquear la pagina. */
        if (isMobile) dialog.show();
        else dialog.showModal();
      }

      closeBtn.addEventListener('click', function () {
        dialog.close();
      });

      var state = readState();

      /* Shopify recarga la pagina al enviar el formulario, asi que el
         agradecimiento solo se ve si volvemos a abrir el dialogo. Este
         cierre no cuenta como descarte: ya esta suscrito. */
      if (dialog.querySelector('[data-prompt-subscribed]')) {
        state.subscribed = true;
        writeState(state);
        reveal();
        return;
      }

      if (state.subscribed) return;
      if (state.nextAt === null) return;
      if (state.nextAt && Date.now() < state.nextAt) return;

      var shown = false;

      function open() {
        if (shown) return;
        shown = true;
        clearTimeout(timer);
        document.removeEventListener('mouseout', onExitIntent);
        reveal();
      }

      function onExitIntent(e) {
        if (e.clientY <= 0 && !e.relatedTarget) open();
      }

      /* Todo descarte pasa por el evento 'close' y solo por ahi — el boton,
         Esc y el click en el backdrop terminan los tres ahi, asi que el
         contador no puede incrementarse dos veces por un mismo cierre. */
      dialog.addEventListener('close', function () {
        var dismissals = (state.dismissals || 0) + 1;
        var days = BACKOFF_DAYS[dismissals - 1];
        state.dismissals = dismissals;
        state.nextAt = days ? Date.now() + days * DAY_MS : null;
        writeState(state);
      });

      var timer = setTimeout(open, DELAY_MS);

      if (!isMobile) document.addEventListener('mouseout', onExitIntent);
    })();
  } catch(e) { console.error(e); }
})();

})();
